module.exports = __webpack_public_path__ + "img/icontype11.389964a7.png";